/**
* @file lazyload
*/

import LazyLoad from "vanilla-lazyload/dist/lazyload.es2015.js";

export default function loadLazyLoading() {
  const images = document.querySelectorAll('[data-src]');
  if(images.length > 0){
    const globalLazyLoader = new LazyLoad({
      threshold: 160,
      class_loading: "js-lazy--loading",
      class_loaded: "js-lazy--loaded",
      class_error: "js-lazy--error"
    });

    const processStepsCarousel = document.querySelector('.process-steps__carousel');
    if(processStepsCarousel) {
      const processStepsLazyLoader = new LazyLoad({
        container: processStepsCarousel,
        threshold: 0,
        class_loading: "js-lazy--loading",
        class_loaded: "js-lazy--loaded",
        class_error: "js-lazy--error"
      });
    }
  }
}

